import { render } from "./TableShimmer.vue?vue&type=template&id=6da2499a"
import script from "./TableShimmer.vue?vue&type=script&lang=js"
export * from "./TableShimmer.vue?vue&type=script&lang=js"
script.render = render

export default script